export const WITH_VERTICAL_SCROLLER_BASE_CLASSES = [
  'h-screen',
  'overflow-auto',
  'scroll-smooth',
  'supports-overlay:overflow-overlay'
];
